import { CATEGORY_MAP } from '@/shared/utils/news/category';

export const goToDetail = (navigate, id: number, category: string) => {
  navigate(`/${CATEGORY_MAP[category]}/${id}`);
};
